import SubComponentRows from './SubComponentRows.component';

export default SubComponentRows;
